import React from 'react';

import { InputBase, inputBaseClasses, styled } from '@mui/material';
import { isNil } from 'lodash';

import classnames from 'classnames';
import EditTextIcon from '../../icons/EditTextIcon';

import './TextEditable.css';

const muiStyles = {
  darkHover: {
    height: '100%',
    fontSize: 12,
    fontWeight: 400,
    width: '100%',
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #fff0',
    transition: 'border 0.2s ease',
    '&:hover': {
      border: '1px solid #b3b3b3',
    },
    [`.${inputBaseClasses.input}`]: {
      fontSize: 12,
      fontWeight: 300,
      color: '#fff',
      padding: 2,
      letterSpacing: 0.5,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  dark: {
    height: '100%',
    fontSize: 12,
    fontWeight: 400,
    width: '100%',
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    [`.${inputBaseClasses.input}`]: {
      fontSize: 12,
      fontWeight: 300,
      color: '#fff',
      padding: 2,
      letterSpacing: 0.5,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  light: {
    height: '100%',
    fontSize: 12,
    fontWeight: 400,
    width: '100%',
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #DFE8F0',
    borderRadius: 2,
    [`.${inputBaseClasses.input}`]: {
      fontSize: 12,
      fontWeight: 400,
      color: '#1F2F40',
      letterSpacing: 0.5,
      padding: 2,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
};

const StyledInputDarkHover = styled(InputBase)(muiStyles.darkHover);
const StyledInputDark = styled(InputBase)(muiStyles.dark);
const StyledInputDefault = styled(InputBase)(muiStyles.light);
class TextEditable extends React.Component {
  render() {
    const { rootStyle, onChange, inputTheme, displayIcon, value, ...otherProps } = this.props;

    const divClassName = classnames('textInput', {
      noborder: this.props.disabled === true,
    });
    const currentValue = !isNil(value) ? value : '';

    let inputField = null;
    switch (inputTheme) {
      case 'darkHover':
        inputField = (
          <StyledInputDarkHover
            margin="dense"
            type="text"
            inputProps={{
              autoComplete: 'new-password',
            }}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            value={currentValue}
            {...otherProps}
          />
        );
        break;
      case 'dark':
        inputField = (
          <StyledInputDark
            margin="dense"
            type="text"
            inputProps={{
              autoComplete: 'new-password',
            }}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            value={currentValue}
            {...otherProps}
          />
        );
        break;

      case 'default':
      default:
        inputField = (
          <StyledInputDefault
            margin="dense"
            type="text"
            inputProps={{
              autoComplete: 'new-password',
            }}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            value={currentValue}
            {...otherProps}
          />
        );
    }

    return (
      <div className={divClassName} style={rootStyle}>
        {this.props.disabled === false && displayIcon === true ? <EditTextIcon /> : null}
        {inputField}
      </div>
    );
  }
}

TextEditable.defaultProps = {
  fullWidth: true,
  disabled: false,
  displayIcon: false,
  inputTheme: 'default',
  rootStyle: {},
};

export default TextEditable;
